import React from 'react'
import NextStep from './NextStep'
import AvailableMethods from '../Components/AvailableMethods'
import SuccessPage from '../Components/SuccessPage'
import MoneyInput from '../Components/MoneyInput'
import SubmitBtn from '../Components/SubmitBtn'
import BankSelect from '../Components/BankSelect'
import BankNone from '../Components/BankNone'
import PHCCon from '$Deposits/Components/PHC'
import { GetParamsData } from '$Deposits/lib/LibCommonData';
import { connect } from "react-redux";

class PHC extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }
    openTutorial =(v)=> {
        const { openTutorial } = GetParamsData()
        openTutorial(v)
    }
    render() {
        console.log("PHC", this.props)

        return (
            <>
                <div className='methodsActive'>
                    <div className='CIC-help' onClick={()=>this.openTutorial("DPHC")}>
                        <span>Hướng Dẫn Gửi Tiền</span>
                    </div>
                    <PHCCon
                        BankNone={BankNone}
                        AvailableMethods={AvailableMethods}
                        BankSelect={BankSelect}
                        MoneyInput={MoneyInput}
                        SubmitBtn={SubmitBtn}
                        NextStep={NextStep}
                        SuccessPage={SuccessPage}
                    />
                    {/* <div className='noteDep'>
                        <b>Lưu ý quan trọng:</b>
                        <ol>
                            <li>Chọn đúng loại thẻ và mệnh giá thẻ cào cần nạp.</li>
                            <li>Số tiền nạp thực tế vào tài khoản của bạn sẽ bằng mệnh giá thẻ cào trừ đi phí nạp tiền.</li>
                            <li>Sau khi nhấp vào nút "Chuyển" cửa sổ bên thứ ba sẽ được mở. 
                                Tại trang gửi tiền bên thứ ba, hãy chọn đúng loại thẻ, mệnh giá thẻ và điền đúng số seri và mã thẻ có trên thẻ của bạn để nạp tiền thành công.</li>
                        </ol>
                    </div> */}
                </div>
            </>

        );
    }
}
const mapStateToProps = state => ({
    BanksBankAccounts: state.BanksBankAccounts,
});
export default connect(mapStateToProps, null)(PHC);

